import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {
	AnalyticTrendingTracks,
	AnalyticTrendingArtists,
	AnalyticTopTracks,
	AnalyticTopArtists,
	AnalyticTimeseries,
	AnalyticContexts,
} from './types';
import type {DataResponseWrapper} from '@deezer/next/services/api/Starmania/requests/types';

const {get} = requestWrapper;

const requests = {
	getTrendingTracks: (country: string) =>
		get<DataResponseWrapper<AnalyticTrendingTracks>>(endpoints.trendingTracks, {
			params: {
				country,
			},
		}),
	getTrendingArtists: (country: string) =>
		get<DataResponseWrapper<AnalyticTrendingArtists>>(
			endpoints.trendingArtists,
			{
				params: {
					country,
				},
			},
		),
	getTopTracks: (country: string) =>
		get<DataResponseWrapper<AnalyticTopTracks>>(endpoints.topTracks, {
			params: {
				country,
			},
		}),
	getTopArtists: (country: string) =>
		get<DataResponseWrapper<AnalyticTopArtists>>(endpoints.topArtists, {
			params: {
				country,
			},
		}),
	getTimeseries: (filters: {
		country: string;
		dateFrom: string;
		dateTo: string;
	}) =>
		get<DataResponseWrapper<AnalyticTimeseries>>(endpoints.timeseries, {
			params: filters,
		}),
	getContexts: (country: string) =>
		get<DataResponseWrapper<AnalyticContexts>>(endpoints.contexts, {
			params: {
				country,
			},
		}),
};

export default requests;
